import Vue from 'vue';
export default Vue.extend({
  data: function () {
    return {};
  },
  beforeMount() {},
  mounted() {},
  methods: {
    btnClickedHandler(params) {
      this.params.clicked(params.data);
    },
  },
  template: `
    <span @click="btnClickedHandler(params)" class="text-danger fw-semibold fs-5" style="cursor: pointer;">{{ $t('network.delete') }}</span>
  `,
});
